import React, { ChangeEvent, useMemo, useState } from "react";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { constant } from "../constants";
import { APIConstants } from "../constants/ApiConstants";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import { useAppSelector } from "../redux/hooks";
import theme from "../theme";
import { useDispatch } from "react-redux";
import { otpActions } from "../redux/slices/otpSlice";
import backgroundImageToLogin from "../assets/loginBG.png";
import useButtonStyles from "../styles/useButtonStyles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getUserFromURL } from "../components/forms/utility";
// import { getGCaptchaToken } from "../services/ApiServices/GetCaptcha";

const paperStyle: React.CSSProperties = {
  width: "75%",
  borderRadius: "16px",
  height: "75%",
  overflow: "hidden",
};
const VerifyOTP = () => {
  const buttonStyles = useButtonStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);
  const [showModel, setShowModal] = useState(false);
  const [modelError, setModelError] = useState(false);

  const HandleOtpChange = (event: ChangeEvent<HTMLInputElement>) => {
    setOtp(event.target.value);
  };
  const email = useAppSelector(
    (state: any) => state.persistReducers.resetPassword.email
  );
  const userTypeFromUrl = useMemo(() => getUserFromURL(), []);

  const HandleOPTSubmit = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.verifyOTP,
        {
          email,
          type: "forgot-password",
          otp,
          user_type: userTypeFromUrl,
        }
      );

      const status = response.data.status;
      if (status) {
        dispatch(
          otpActions.updateOtp({
            otp: otp,
          })
        );
        navigate("/resetPassword");
      }
    } catch (error: any) {
      console.error(error);
      setLoading(false);
      setError(error?.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  // const handleResetPasswordClick = async () => {
  //   const result = await getGCaptchaToken();
  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       process.env.REACT_APP_API_URL_PHASE_2 +
  //         "v2/" +
  //         APIConstants.forgotPassword,
  //       {
  //         email,
  //         type: "forgot-password",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CAP-INTEGRATIONS-GEOFENCE-KEY":
  //             process.env.REACT_APP_GEO_FENCING_KEY,
  //           "X-INTEGRATIONS-RECAPTCHA-TOKEN": result as any,
  //           "X-INTEGRATIONS-RECAPTCHA-ACTION": "FORGOT-PASSWORD",
  //           "DEVICE-TYPE": "webapp",
  //         },
  //       }
  //     );

  //     const status = response.data.status;
  //     if (status) {
  //       setShowModal(true);
  //     }
  //   } catch (error: any) {
  //     if (error?.response?.data?.message) {
  //       setError(error?.response?.data?.message);
  //     }
  //     setLoading(false);
  //     setModelError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleResetPasswordClick = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.forgotPassword,
        {
          email,
          type: "forgot-password",
        }
      );

      const status = response.data.status;
      if (status) {
        setShowModal(true);
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setError(error?.response?.data?.message);
      }
      setLoading(false);
      setModelError(true);
    } finally {
      setLoading(false);
    }
  };
  const backToForgotPassword = () => {
    navigate("/login");
  };

  return (
    <Grid
      display={"flex"}
      height={"100vh"}
      justifyContent={"space-around"}
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "space-around",
        opacity: 1,
        backgroundImage: `url(${backgroundImageToLogin})`,

        backgroundSize: "cover",
      }}
    >
      <Grid
        width={"40%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img
          src={require("../assets/suntecLogo.png")}
          alt="Logo"
          style={{ maxWidth: "60%", maxHeight: "60%" }}
        />
      </Grid>
      <Grid
        width={"40%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Paper
          style={paperStyle}
          elevation={5}
          sx={{
            display: "flex",
            justifyContent: "center",
            direction: "column",
          }}
        >
          <Grid container display={"flex"} py={4}>
            <Grid
              textAlign={"center"}
              alignContent={"center"}
              display={"flex"}
              direction={"column"}
              width={"100%"}
            >
              <Grid display={"flex"} justifyContent={"left"}>
                <IconButton sx={{ ml: 2 }} onClick={backToForgotPassword}>
                  <ArrowBackIcon
                    sx={{ color: theme.color?.newFilterGrey }}
                  ></ArrowBackIcon>
                </IconButton>
              </Grid>
              <Grid
                height={"100%"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-evenly"}
                px={8}
              >
                <Grid
                  sx={{
                    display: "flex",
                    direction: "column",
                  }}
                >
                  <Typography
                    align="left"
                    display={"flex"}
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontWeight: theme.font?.fontWeight.thick,
                      fontSize: "32px",
                      textAlign: "left",
                    }}
                  >
                    Enter OTP
                  </Typography>
                </Grid>
                <Grid>
                  <Typography
                    align="left"
                    display={"flex"}
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontWeight: theme.font?.fontWeight.slightThick,
                      fontSize: theme.font?.fontSize.tableHeader,
                      mb: 0.5,
                    }}
                  >
                    Enter the OTP sent to your registered email.
                  </Typography>
                  <Grid display={"flex"}>
                    <TextField
                      id="OTP"
                      variant="outlined"
                      type="number"
                      fullWidth
                      size="small"
                      value={otp}
                      onChange={HandleOtpChange}
                    />
                  </Grid>
                  <Grid item>
                    {error && (
                      <Typography
                        color={theme.color?.error}
                        align="center"
                        display={"flex"}
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableBody,
                          mt: 0.5,
                        }}
                      >
                        {error}
                      </Typography>
                    )}
                    {success && (
                      <Typography
                        color={theme.color?.success}
                        align="center"
                        display={"flex"}
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableBody,
                          mt: 0.5,
                        }}
                      >
                        OTP verifcation successful!
                      </Typography>
                    )}
                    <Button
                      fullWidth
                      type="submit"
                      sx={{ ...buttonStyles.containedSecondary, mt: 4 }}
                      onClick={HandleOPTSubmit}
                    >
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      type="button"
                      sx={{
                        ...buttonStyles.textSecondary,
                        fontFamily: theme.font?.fontFamily.primary,
                        fontWeight: theme.font?.fontWeight.thick,
                        fontSize: theme.font?.fontSize.tableHeader,
                        mt: 4,
                      }}
                      onClick={handleResetPasswordClick}
                    >
                      Resend OTP
                    </Button>
                  </Grid>
                </Grid>
                <Grid display={"flex"} flexDirection={"column"} width={"100%"}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableBody,
                      fontWeight: theme.font?.fontWeight.slightThick,
                      color: theme.color?.newFilterGrey,
                    }}
                    display="flex"
                  >
                    If you did not receive, please contact
                  </Typography>
                  <Grid display={"flex"} gap={1} alignItems={"center"}>
                    <a
                      style={{
                        color: theme.color?.secondary,
                        display: "flex",
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.tableBody,
                      }}
                      href="mailto:suntecplus@apmasia.com.sg"
                    >
                      suntecplus@apmasia.com.sg
                    </a>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.tableBody,
                        fontWeight: theme.font?.fontWeight.slightThick,
                        color: theme.color?.newFilterGrey,
                      }}
                    >
                      for assistance
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {loading && <BasicModal content={<Loader />} />}
        </Paper>
        {showModel && (
          <BasicModal
            title={"OTP sent successfully"}
            success={true}
            setState={setShowModal}
          />
        )}
        {modelError && (
          <BasicModal title={error} success={false} setState={setModelError} />
        )}
      </Grid>
    </Grid>
  );
};

export default VerifyOTP;
